/**
 * HomeGroupWA Display Homes Subsite JS Include
 *
 * @author Red Tiki <info@redtiki.com.au>
 */
const displayHomeMarker = require('../../images/homegroup/display_home_marker_one.png');
const displayHomeMarkerTwo = require('../../images/homegroup/display_home_marker_two.png');

window.DisplayHomesSubsitePageObject = function(opts) {
    var displayhomespage_obj = $.extend(new window.PageObject({}), {
        //page interactivity
        setup: function() {
            var self = this;

            if ($('#display-home__modal').data('display')) {
                $('#display-home__modal').modal('show');
            }

            $('#display-home__modal').on('hidden.bs.modal', function(e) {
                $('#display-home__modal .modal-content')
                    .html('')
                    .removeClass('content-loaded');
                clearTimeout(self.spamTimer);
            });

            $('.display-home > a').on('touchstart click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                var link = $(this).attr('href');
                var title = $(this).data('title');
                var id = $(this).data('design');

                $('#display-home__modal').modal('show');

                //try to limit spam clicks
                clearTimeout(self.spamTimer);
                self.spamTimer = setTimeout(function() {
                    $.ajax({
                        url: link,
                        dataType: 'html'
                    })
                        .done(function(data) {
                            $('#display-home__modal .modal-content').html(data);

                            var designTitle = $('.modal-footer h2')
                                .first()
                                .text(); //get property title
                            //self.updateModalLivechatBtn();
                            self.updateModalContactData(id);
                            self.changePage(link, 'HomeDesignPage', self.pageID + '-' + id, title);
                            //self.trackPageView(link, title);

                            $('#display-home__modal')
                                .imagesLoaded()
                                .done(function() {
                                    $('#display-home__modal').modal('handleUpdate'); //Update backdrop on modal show
                                });

                            self.setupMap();
                        })
                        .fail(function() {
                            window.location = link;
                        });
                }, 200);
            });
        },

        setupMap: function() {
            if (!$('#display-home-map').length) return false;

            var self = this;

            var mapMarkers = [];
            var markerBounds = new google.maps.LatLngBounds();
            var defaultZoom = $('#display-home-map').data('defaultZoom');

            var mapOptions = {
                zoom: opts.mapZoomLevel ? opts.mapZoomLevel : defaultZoom,
                center: new google.maps.LatLng(-25.363882, 131.044922),
                //disableDefaultUI: true,
                scrollwheel: false
            };

            const mapDiv = document.getElementById('display-home-map');
            if (mapDiv) {
                var map = new google.maps.Map(mapDiv, mapOptions);

                var markerElements = $('.display-home-info');

                if (markerElements.length) {
                    markerElements.each(function() {
                        var latitude = $(this).data('lat');
                        var longitude = $(this).data('lng');
                        var title = $(this).data('title');
                        var storeys = parseInt($(this).data('storeys'));
                        var itemID = $(this).data('itemid');

                        var pos = new google.maps.LatLng(parseFloat(latitude), parseFloat(longitude));
                        var marker = new google.maps.Marker({
                            position: pos,
                            map: map,
                            title: title,
                            animation: google.maps.Animation.DROP,
                            contentID: itemID
                        });

                        if (storeys === 1) {
                            marker.setIcon(displayHomeMarker);
                        } else {
                            marker.setIcon(displayHomeMarkerTwo);
                        }

                        mapMarkers.push(marker);
                        markerBounds.extend(pos);
                    });

                    google.maps.event.addListenerOnce(map, 'idle', function() {
                        map.fitBounds(markerBounds);
                        map.setZoom(defaultZoom);
                        if (opts.mapZoomLevel > 0) {
                            map.setZoom(opts.mapZoomLevel);
                        }
                    });
                }
            }
        },

        setupForm: function() {
            var lowerRange = $("select[name='LowerRange']");
            var upperRange = $("select[name='UpperRange']");

            lowerRange.on('change', function(e) {
                if ($(this).prop('selectedIndex') > upperRange.prop('selectedIndex')) {
                    $(this).prop('selectedIndex', upperRange.prop('selectedIndex'));
                }
            });

            upperRange.on('change', function(e) {
                if ($(this).prop('selectedIndex') < lowerRange.prop('selectedIndex')) {
                    lowerRange.prop('selectedIndex', $(this).prop('selectedIndex'));
                }
            });
        },

        updateModalContactData: function(id) {
            if (id) {
                $('.price-enquiry a').data('design', id);
            }
        },

        debounce: function(func, wait, immediate) {
            var timeout;
            return function() {
                var context = this,
                    args = arguments;
                var later = function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        },

        //event handlers...
        onInit: function() {},
        onReady: function() {
            this.setup();
            this.setupForm();
        },
        onResize: function() {},
        onLoad: function() {
            this.setupMap();
        }
    });

    if (opts) {
        return $.extend(displayhomespage_obj, opts);
    } else {
        return displayhomespage_obj;
    }
};
